var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { continuationErrorMessage } from "../constants/FeatureDataConstants.js";
import { onError } from "@ane/core/lib/decorators/OnError";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let GatingV2Resource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api/2.0/");
  }
  getTransitionGate(transitionGateName) {
    return __async(this, null, function* () {
      const address = `experiments/transitionGate/${transitionGateName}`;
      const response = yield this._get(address);
      return response.isSuccessful() ? { error: "", result: response.getSuccessData() } : { error: response.getError(response), result: null };
    });
  }
  experimentHasGate(stepId, gateName) {
    return __async(this, null, function* () {
      const address = `experiments/steps/${stepId}/gates/${gateName}`;
      const response = yield this._get(address);
      return response.isSuccessful() ? { error: "", result: response.getSuccessData() } : { error: response.getError(response), result: null };
    });
  }
  flightHasGate(target, gateName) {
    return __async(this, null, function* () {
      const address = `experiments/flights/${target}/gates/${gateName}`;
      const response = yield this._get(address);
      return response.isSuccessful() ? { error: "", result: response.getSuccessData() } : { error: response.getError(response), result: null };
    });
  }
  updateExperimentGate(stepId, gateName, state, comment, content) {
    return __async(this, null, function* () {
      const commentQuery = !!comment ? `&comment=${comment}` : ``;
      const address = `experiments/steps/${stepId}/gates/${gateName}?state=${state}${commentQuery}`;
      const response = yield this._put(content, address);
      return response.isSuccessful() ? { error: "", result: response.getSuccessData() } : { error: response.getError(response), result: null };
    });
  }
  updateFlightGate(target, gateName, state, comment, content) {
    return __async(this, null, function* () {
      const commentQuery = !!comment ? `&comment=${comment}` : ``;
      const address = `experiments/flights/${target}/gates/${gateName}?state=${state}${commentQuery}`;
      const response = yield this._put(content, address);
      return response.isSuccessful() ? { error: "", result: response.getSuccessData() } : { error: response.getError(response), result: null };
    });
  }
};
__decorateClass([
  onError({ message: `There was an error retrieving gate. ${continuationErrorMessage}` })
], GatingV2Resource.prototype, "getTransitionGate", 1);
__decorateClass([
  onError({ message: `There was an error validating experiment gate. ${continuationErrorMessage}` })
], GatingV2Resource.prototype, "experimentHasGate", 1);
__decorateClass([
  onError({ message: `There was an error validating flight gate. ${continuationErrorMessage}` })
], GatingV2Resource.prototype, "flightHasGate", 1);
__decorateClass([
  onError({ message: `There was an error while updating gate. ${continuationErrorMessage}` })
], GatingV2Resource.prototype, "updateExperimentGate", 1);
__decorateClass([
  onError({ message: `There was an error while updating gate. ${continuationErrorMessage}` })
], GatingV2Resource.prototype, "updateFlightGate", 1);
GatingV2Resource = __decorateClass([
  WPSProxyConverter()
], GatingV2Resource);
const GatingV2Resource$1 = new GatingV2Resource();
export {
  GatingV2Resource,
  GatingV2Resource$1 as default
};
//# sourceMappingURL=GatingV2Resource.js.map
